import React from "react";
import { monthConverter } from "utils/common";
import { getInterpretasi } from "utils/helpers";

const TableComponent = ({ reportsData, tableRef, reportInfo }) => {
  const renderTableByLevel = () => {
    return (
      <>
        <thead>
          <tr>
            <th>No</th>
            <th>Nama</th>
            <th>Kode side</th>
            <th>Tanggal slide dikirim</th>
            <th>Hasil pemeriksaan</th>
            <th>Jenis parasit</th>
            <th>Hasil verifikasi kab/kota</th>
            <th>Hasil Verif Prov</th>
            <th>Interpretasi hasil - tingkat 2</th>
            <th>Interpretasi hasil - tingkat 3</th>
            <th>Interpretasi Akurasi Spesies - tingkat 2</th>
            <th>Interpretasi Akurasi Spesies - tingkat 3</th>
          </tr>
        </thead>
        <tbody>
          {reportsData.length !== 0 ? (
            reportsData?.map((item, index) => {
              const parasyte =
                item?.slide === "negatif" ? ["Negatif"] : item?.parasyte ?? [];
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.name}</td>
                  <td>{item?.slide_code}</td>
                  <td>{item?.tgl_slide_dikirim}</td>
                  <td style={{ textTransform: "capitalize" }}>{item?.slide}</td>
                  <td>{item?.parasyte?.join(", ")}</td>
                  <td>{item?.hasil_kabkota}</td>
                  <td>{item?.hasil_prov}</td>
                  <td>{getInterpretasi(item?.hasil_kabkota, parasyte)}</td>
                  <td>{getInterpretasi(item?.hasil_prov, parasyte)}</td>
                  <td>{item?.interpretasi_akurasi_spesies_tier2 ?? ""}</td>
                  <td>{item?.interpretasi_akurasi_spesies_tier3 ?? ""}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={12}>Tidak ada data</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  let levelName = "Fasyankes";

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none", padding: 0 }}>
          <th style={{ border: "none", paddingBottom: "0" }}>
            <h3>SISMAL v3, UJI SILANG INDIVIDU</h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {reportInfo?.statusPeriode === "monthly" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
          </th>
        </tr>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
